export default "__VITE_ASSET__Bvp74lCQ__"